import { HttpRequestStatus } from 'model/enums/httpRequestStatus';
import { Reducer } from 'redux';
import { GetYearlyIncomeStatementState, GetYearlyIncomeStatementTypes } from './types';

const initialState: GetYearlyIncomeStatementState = {
    status: HttpRequestStatus.NOOP,
    yearlyIncomeStatement: undefined,
    error: undefined
};

const reducer: Reducer<GetYearlyIncomeStatementState> = (state = initialState, action): GetYearlyIncomeStatementState => {
    switch (action.type) {
        case GetYearlyIncomeStatementTypes.GET_YEARLY_INCOME_STATEMENT_REQUEST: {
            return { ...state, status: HttpRequestStatus.ONGOING, error: undefined };
        }
        case GetYearlyIncomeStatementTypes.GET_YEARLY_INCOME_STATEMENT_SUCCESS: {
            return { ...state, status: HttpRequestStatus.SUCCESS, yearlyIncomeStatement: action.payload, error: undefined };
        }
        case GetYearlyIncomeStatementTypes.GET_YEARLY_INCOME_STATEMENT_ERROR: {
            return { ...state, status: HttpRequestStatus.ERROR, error: action.payload };
        }
        case GetYearlyIncomeStatementTypes.GET_YEARLY_INCOME_STATEMENT_RESET_STATE: {
            return initialState;
        }
        default: {
            return state;
        }
    }
};

export { reducer as getYearlyIncomeStatementReducer };
